module.exports = __webpack_public_path__ + "static/media/offering-image-four.d376812d.png";